import React from 'react'

const MatchRequestScreen = ({ 
  gameState, 
  matchRequestData, 
  onAccept, 
  onDecline, 
  onCancel 
}) => {
  // Handle all request sent states (initial match, play again, or chat)
  if ((gameState === 'match_request_sent' || gameState === 'play_again_request_sent' || gameState === 'chat_request_sent') && matchRequestData) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="max-w-2xl w-full">
          <div className="card-retro p-8 text-center">
            <h2 className="text-2xl font-bold text-neon-blue mb-6">
              {gameState === 'chat_request_sent' ? 'Chat Request Sent' : 'Let\'s play!'}
            </h2>
            <p className="text-purgatory-mist mb-6">
              {gameState === 'chat_request_sent' ? 'Chat request sent to:' : 'You\'ve sent a request to:'}
            </p>
            <div className="text-6xl mb-6">{matchRequestData.target_identity || matchRequestData.partner_identity}</div>
            <button
              onClick={onCancel}
              className="btn-retro btn-danger"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )
  }

  // Handle all request received states (initial match, play again, or chat)
  if ((gameState === 'match_request_received' || gameState === 'play_again_request_received' || gameState === 'chat_request_received') && matchRequestData) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="max-w-2xl w-full">
          <div className="card-retro p-8 text-center">
            <h2 className="text-2xl font-bold text-purgatory-gold mb-6">
              {gameState === 'chat_request_received' ? 'Chat Request' : 'Want to play?'}
            </h2>
            <p className="text-purgatory-mist mb-6">
              {gameState === 'chat_request_received' ? 'wants to chat with you' : 'Another soul wants to play'}
            </p>
            <div className="text-6xl mb-8">{matchRequestData.requester_identity}</div>
            <div className="flex gap-4 justify-center">
              <button
                onClick={onAccept}
                className="btn-retro px-8 py-3 text-lg"
              >
                {gameState === 'chat_request_received' ? 'Accept' : 'Accept'}
              </button>
              <button
                onClick={onDecline}
                className="btn-retro btn-danger px-8 py-3 text-lg"
              >
                {gameState === 'chat_request_received' ? 'Reject' : 'Reject'}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return null
}

export default MatchRequestScreen
